import React, { ReactNode, useEffect, useRef } from 'react';

export enum AccordionVariant {
    DEFAULT = 'default', // default
    SLIM = 'slim'
}

interface IAccordion {
    // attributes
    analytics?: { [key: string]: string };
    dark?: boolean;
    identifier?: string;
    open?: boolean;
    variant?: AccordionVariant;
    children: ReactNode;
    // events
    onOpenOrClose?: (isOpen: boolean) => void;
    onClick?: () => void;
    // extra nous
    dataTestId?: string;
}

export const Accordion: React.FC<IAccordion> = ({
    // attributes
    analytics,
    dark,
    identifier,
    open,
    variant,
    children,
    // events
    onOpenOrClose,
    onClick,
    //extra nous
    dataTestId
}) => {
    const ref = useRef(null);
    const handleOpenOrClose = (e) => {
        onOpenOrClose(e.target.open);
    };

    useEffect(() => {
        ref.current.addEventListener('dsdAccordionChange', (e) => {
            if (onOpenOrClose) handleOpenOrClose(e);
        });
        ref.current.addEventListener('dsdAccordionClick', () => {
            if (onClick) onClick();
        });
    }, []);

    return (
        // @ts-ignore
        <dsd-accordion
            ref={ref}
            analytics={analytics}
            dark={dark}
            identifier={identifier}
            open={open}
            variant={variant}
            data-testid={dataTestId}
        >
            {children}
            {/* @ts-ignore */}
        </dsd-accordion>
    );
};
